export const PERSON_BY_LEGAL_ID_SUCCESS = 'PERSON_BY_LEGAL_ID_SUCCESS';
export const PERSON_BY_LEGAL_ID_FAIL = 'PERSON_BY_LEGAL_ID_FAIL';
export const PERSON_BY_LEGAL_ID_LOAD = 'PERSON_BY_LEGAL_ID_LOAD';
export const PERSON_BY_LEGAL_ID_CLEAR = 'PERSON_BY_LEGAL_ID_CLEAR';
export const PERSON_SEARCH_NOT_FOUND = 'PERSON_SEARCH_NOT_FOUND';
export const PERSON_BY_LEGAL_CLEAR_REQUEST_ANSWER = 'PERSON_BY_LEGAL_CLEAR_REQUEST_ANSWER';
